const MAGNIFY_ZOOM_RATIO = 2;
const MAGIC_ZOOM_RATIO = 2.5;

function getZoomImageUrl(image) {
  const srcset = image.getAttribute('srcset');
  if (srcset) {
    let bestUrl = image.currentSrc || image.src;
    let bestWidth = 0;
    srcset.split(',').forEach((part) => {
      const pieces = part.trim().split(/\s+/);
      const url = pieces[0];
      const width = parseInt(pieces[1], 10);
      if (width > bestWidth) {
        bestWidth = width;
        bestUrl = url;
      }
    });
    return bestUrl;
  }
  return image.currentSrc || image.src;
}

function prepareOverlay(container, imageUrl) {
  container.className = 'image-magnify-full-size';
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${imageUrl}')`;
  container.style.backgroundColor = 'rgb(var(--color-background))';
}

function moveWithHover(image, overlay, event, zoomRatio) {
  const rect = image.getBoundingClientRect();
  if (!rect.width || !rect.height) return;

  const x = event.clientX - rect.left;
  const y = event.clientY - rect.top;
  const xPercent = (x / rect.width) * 100;
  const yPercent = (y / rect.height) * 100;

  overlay.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
  overlay.style.backgroundSize = `${rect.width * zoomRatio}px auto`;
}

function createOverlay(image) {
  const overlay = document.createElement('div');
  prepareOverlay(overlay, getZoomImageUrl(image));
  image.parentElement.insertBefore(overlay, image);
  return overlay;
}

function magnifyOnClick(image, zoomRatio, event) {
  const overlay = createOverlay(image);
  const cleanup = () => overlay.remove();

  overlay.addEventListener('click', cleanup);
  overlay.addEventListener('mouseleave', cleanup);
  overlay.addEventListener('mousemove', (e) => moveWithHover(image, overlay, e, zoomRatio));
  moveWithHover(image, overlay, event, zoomRatio);
}

function enableZoomOnHover(zoomRatio = MAGNIFY_ZOOM_RATIO) {
  document.querySelectorAll('.image-magnify-hover').forEach((image) => {
    if (image.dataset.magnifyClickBound) return;
    image.dataset.magnifyClickBound = '1';
    image.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      magnifyOnClick(image, zoomRatio, event);
    });
  });
}

function enableMagicZoom(zoomRatio = MAGIC_ZOOM_RATIO) {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  document.querySelectorAll('.image-magnify-magic').forEach((image) => {
    const container = image.closest('.product__modal-opener--image');
    if (!container || container.dataset.magicZoomBound) return;
    container.dataset.magicZoomBound = '1';

    let overlay = null;

    const onLeave = () => {
      if (!overlay) return;
      overlay.remove();
      overlay = null;
    };

    const onMove = (event) => {
      if (!overlay) return;
      moveWithHover(image, overlay, event, zoomRatio);
    };

    const onEnter = (event) => {
      if (overlay) return;
      overlay = createOverlay(image);
      moveWithHover(image, overlay, event, zoomRatio);
    };

    container.addEventListener('mouseenter', onEnter);
    container.addEventListener('mousemove', onMove);
    container.addEventListener('mouseleave', onLeave);
  });
}

function initProductZoom() {
  enableZoomOnHover(MAGNIFY_ZOOM_RATIO);
  enableMagicZoom(MAGIC_ZOOM_RATIO);
}

window.enableZoomOnHover = enableZoomOnHover;
window.enableMagicZoom = enableMagicZoom;
window.initProductZoom = initProductZoom;

initProductZoom();
